
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/topsort",
      function () {
        return require("private-next-pages/destinations/topsort.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/topsort"])
      });
    }
  